import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchUsersAsync,
  resetAdminState,
  setSelectedUser,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import SearchInput from "../../../../components/form/SearchInput";
import Button from "../../../ui/Button";
import moment from "moment";
import DateRangeSelector, {
  DateRangeType,
} from "../../../ui/DateRangeSelector";
import { useNavigate } from "react-router-dom";

const BuyerTable: React.FC = () => {
  const { buyers, isLoading } = useAppSelector((state) => state.admin);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: null,
    endDate: null,
  });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Buyer", field: "buyer_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Country", field: "country" },
    { label: "Reg. Date", field: "date_added" },
  ];

  const buyersData = buyers?.data?.data?.map((buyer: any, index: number) => {
    return {
      _buyer: buyer,
      id: index + 1,
      buyer_name: buyer?.fullName ?? "N/A",
      username: buyer?.username ?? "N/A",
      phone_number: buyer?.phoneNumber ?? "N/A",
      country:
        (typeof buyer?.country === "string"
          ? buyer?.country
          : buyer?.country?.name) ?? "N/A",
      email: buyer?.email ?? "N/A",
      date_added: moment(buyer?.createdAt).format("MMM DD, YYYY"),
    };
  });

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(
      fetchUsersAsync({
        page: page + 1,
        limit,
        filter,
        userType: "BUYER",
        startDate: selectedRange.startDate,
        endDate: selectedRange.endDate,
      }),
    );
  }, [page, limit, filter, dispatch, selectedRange]);

  const tabList = [
    { id: 1, name: "All Buyers", count: buyers?.data?.totalItems ?? 0 },
  ];

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilter(inputValue);
    }
  };

  return (
    <WhiteTitledCard>
      <div className="px-4">
        <div className="flex flex-col md:justify-between gap-4 mb-4">
          {/* Tabs List */}
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 w-full md:w-auto">
            <DateRangeSelector
              initialRange={selectedRange}
              onChange={handleDateChange}
            />
            <div className="flex gap-2">
              <SearchInput
                placeholder="Search"
                onChange={(e: any) => {
                  setInputValue(e.target.value);
                  setPage(0);
                }}
                value={inputValue}
                onKeyDown={handleKeyDown}
              />
              <Button
                customStyle={{
                  width: "auto",
                  height: "40px",
                }}
                label="Filter"
                onClick={() => setFilter(inputValue)}
                classNames="hidden sm:flex"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap items-center gap-3">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className="space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary"
              >
                <span>{tab.name}</span>
                <span className="bg-lightPurple px-2 text-accent rounded-md">
                  {tab?.count}
                </span>
              </div>
            ))}
          </div>
        </div>

        <CustomTable
          data={{ columns, rows: buyersData }}
          onRowClick={(row) => {
            dispatch(setSelectedUser(row._buyer));
            navigate(`/user-management/buyer/${row._buyer?.id}`);
          }}
          noRecordText="No buyer Users Available"
          loading={isLoading}
          showFooter={true}
          totalPages={buyers?.data?.totalPages}
          itemsPerPage={buyers?.data?.itemsPerPage}
          currentPage={page}
          onPageChange={(value: number) => setPage(value)}
          onLimitChange={(value: number) => {
            setLimit(value);
            setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default BuyerTable;
